import { Button } from '@/components/Button';

interface TutorialStep1Props {
  onNext: () => void;
}

export default function TutorialStep1({ onNext }: TutorialStep1Props) {
  return (
    <>
      {/* ステップタイトル */}
      <div className="flex w-full items-center justify-center py-xs">
        <h2 className="text-lg leading-normal font-bold text-black/70">
          ① 連携したいアカウントを選択
        </h2>
      </div>

      <div className="flex justify-center p-md">
        <img src="/agent/trial/step1.png" alt="" width={424} height={272} />
      </div>

      {/* 進捗インジケーター */}
      <div className="flex h-xxl items-center justify-center gap-[11px]">
        <div className="size-[10px] rounded-full bg-primary" />
        <div className="size-[10px] rounded-full border border-solid border-primary" />
        <div className="size-[10px] rounded-full border border-solid border-primary" />
      </div>

      {/* 次へボタン */}
      <div className="flex justify-center py-xs">
        <Button color="primary" size="lg" className="h-[52px] w-[200px]" onClick={onNext}>
          次へ
        </Button>
      </div>
    </>
  );
}
